/**
 * #760 — Sample 2.0 Meta tracking
 * --------------------------------
 * Surface a `productFinderStart` dataLayer event the moment a customer
 * begins the Product Finder quiz. The `gtm-product-finder-start` className
 * is already attached to the start CTAs by `theme/snippets/fifty-fifty-banner.liquid`
 * (rendered on `/pages/product-finder` and `/pages/product-samples`); this
 * module attaches a single delegated listener on `document` so the event
 * fires reliably without depending on GTM trigger configuration that has
 * historically been brittle to update.
 *
 * Why a delegated listener: the start CTAs are rendered as plain `<a>`
 * tags inside Liquid templates that are not Vue-mounted. Delegated `click`
 * handlers on `document` survive any DOM re-paint (slick, lazy banners,
 * announcement-bar swaps).
 */
import { setGTMdataLayerEvents } from './helpers';

const PRODUCT_FINDER_START_SELECTOR = '.gtm-product-finder-start';

const resolveEntry = (target) => {
  if (!target) return 'unknown';

  // Walk up to find a meaningful container so attribution distinguishes
  // /pages/product-finder hero CTA from /pages/product-samples hero CTA.
  if (target.closest('[data-product-finder-entry]')) {
    return target
      .closest('[data-product-finder-entry]')
      .getAttribute('data-product-finder-entry');
  }
  if (window?.location?.pathname?.includes('/pages/product-samples')) {
    return 'product-samples-page';
  }
  if (window?.location?.pathname?.includes('/pages/product-finder')) {
    return 'product-finder-page';
  }
  return 'unknown';
};

const handleClick = (event) => {
  const trigger = event.target?.closest?.(PRODUCT_FINDER_START_SELECTOR);
  if (!trigger) return;
  setGTMdataLayerEvents('product-finder-start', [], resolveEntry(trigger));
};

const ProductFinderTracking = () => {
  // Idempotency guard — components/index.js may run twice on hot reload.
  if (window.__tenaProductFinderStartBound) return;
  window.__tenaProductFinderStartBound = true;
  document.addEventListener('click', handleClick, { capture: true });
};

export default ProductFinderTracking;
